import Footer from "../../components/layout/footer/Footer";
import AboutApp from "../../components/about/AboutApp";

import Contact from "../../components/contact/Contact";

import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";

import PromoTwo from "../../components/promo/PromoTwo";
import VideoPromoTwo from "../../components/promo/VideoPromoTwo";
import HeroTwo from "./HeroTwo";

import { Helmet } from 'react-helmet-async';



export default function HomeTwo() {
  return (
    <>
   
    <Layout>
      <Navbar  />
      <HeroTwo />
      <PromoTwo />
      <AboutApp />
  
     


     <VideoPromoTwo/>
      
      <Contact bgColor="gray-light-bg" />

      <Footer space />
    </Layout></>
  );
}
